const NAMESPACE = "envelopeItemStatus";

const KEYS = {
    noFileUploadedText: "noFileUploadedText"
};

const MESSAGES = {
    [KEYS.noFileUploadedText]: {
        value: "No file uploaded",
        comment: "Placeholder text for wet sign item where no doc has been uploaded"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
